import React from 'react';

import SalonFlag from 'components/core/SalonFlag.component';
import SF from 'constants/salonFlag.const';

const OLD_SMS_PRICE = 5;
const NEW_SMS_PRICE = 6;

const SmsPrice = () => (
  <SalonFlag name={SF.smsPricing}>
    <SalonFlag.IfDisabled>{NEW_SMS_PRICE}</SalonFlag.IfDisabled>
    <SalonFlag.IfEnabled>{OLD_SMS_PRICE}</SalonFlag.IfEnabled>
  </SalonFlag>
);

export default SmsPrice;
